import React from 'react';
import moment from 'moment';
import { useQuery } from '@apollo/react-hooks';
import { ExcellenceClubDealerCardGenerico } from '../ExcellenceClubDealerCardGenerico/ExcellenceClubDealerCardGenerico';
import { TipoIndicadorExcellenceClubCard } from '../../../../../../../core/Enums';
import { useStateMarca } from '../../../../indicadoresHooks';
import { getLocalDateTimeString } from '../../../../../../utils/dateUtils';
import { BONUS_PERFORMANCE_QUERY } from '../data/BONUS_PERFORMANCE_QUERY';
import { CardLoading } from '../../../../../../utils/CardLoading';

export const BonusPerformanceCard = React.memo(
  ({
    setMarcaDialog,
    setDataInicialDialog,
    setDataFinallDialog,
    setShowVendedoresExcellenceClub,
    setTituloDialogVendedores,
    setDialogComponent,
    setEntidades,
    setPorcentagemDialog,
    marcas,
    dealerId,
    unidadeNegocioId,
    showDialogAtividades,
    setVendedorFiltro,
  }) => {
    const dataInicial = moment().startOf('quarter');
    const dataFinal = moment().endOf('day');
    const [marca, setMarca] = useStateMarca(marcas);

    const {
      loading,
      data: {
        indicadorBonusPerformance: {
          qtdFup48,
          qtdTD,
          qtdVendas,
          qtdEmplacados,
          idsVendas,
          porcentagemTDRealizado,
          porcentagemFup48Realizado,
          qtdPorcentagemVendasxEmplacados,
          qtdPontos,
          total,
          porcentagem,
          qtdIndicadoresIncompletos: valorIncompleto,
        } = {},
      } = {},
    } = useQuery(BONUS_PERFORMANCE_QUERY, {
      variables: {
        dataInicio: getLocalDateTimeString(dataInicial),
        dataFim: getLocalDateTimeString(dataFinal),
        dealerPk: dealerId,
        marcaId: marca,
        unidadeNegocioId,
      },
    });

    /**
     * FIXME: isso deve utilizar um wrapper componente como um HOC, que faz o branch
     * */
    if (loading) {
      return <CardLoading />;
    }

    return (
      <ExcellenceClubDealerCardGenerico
        setMarcaDialog={setMarcaDialog}
        setDataInicialDialog={setDataInicialDialog}
        setDataFinallDialog={setDataFinallDialog}
        dataInicial={dataInicial}
        dataFinal={dataFinal}
        titulo="Bônus Performance"
        qtdFup48={qtdFup48}
        qtdTD={qtdTD}
        qtdVendas={qtdVendas}
        qtdEmplacados={qtdEmplacados}
        qtdPontos={qtdPontos}
        slidePorcentagem
        porcentagem={porcentagem}
        porcentagemFup48Realizado={porcentagemFup48Realizado}
        porcentagemTDRealizado={porcentagemTDRealizado}
        qtdPorcentagemVendasxEmplacados={qtdPorcentagemVendasxEmplacados}
        total={total}
        marca={marca}
        marcas={marcas}
        setMarca={setMarca}
        setVendedorFiltro={setVendedorFiltro}
        setTituloDialogVendedores={setTituloDialogVendedores}
        setShowVendedoresExcellenceClub={setShowVendedoresExcellenceClub}
        setDialogComponent={setDialogComponent}
        setEntidades={setEntidades}
        setPorcentagemDialog={setPorcentagemDialog}
        idsVendas={idsVendas}
        showDialogAtividades={showDialogAtividades}
        valorIncompleto={valorIncompleto}
        tipoIndicadorExcellenceClubCard={
          TipoIndicadorExcellenceClubCard.BONUS_PERFORMANCE
        }
      />
    );
  }
);
